/**
 * Functionality used in multiple Campaign-related components.
 *
 * Depends on:
 *   - this.$store.state.common.userWritableStores
 */
const campaigns = {
  methods: {
    /**
     * Return a filtered list of Stores that match the Campaign.
     *
     * The initial list of Stores is expected to exist in the Store:
     * We filter it based on its Group and their hierarchy, accepting
     * a Store when the Campaign can be activated in it.
     */
    availableStoresForCampaign(campaign) {
      const campaignGroupId = campaign.group.id;
      const allStores = this.$store.state.common.userWritableStores;
      const matching = allStores.filter((store) => {
        const storeMatchesGroup =
          store.groups.indexOf(campaignGroupId) !== -1 ||
          store.content_groups.indexOf(campaignGroupId) !== -1;
        return storeMatchesGroup;
      });
      return matching;
    },
  },
};

export default campaigns;



// WEBPACK FOOTER //
// ./src/mixins/campaigns.js